import { useNavigate } from 'react-router-dom';
import styles from './styles.module.scss';

type Directions = 'up' | 'down' | 'left' | 'right';
interface Props extends React.HTMLAttributes<HTMLDivElement> {
    direction?: Directions;
    route?: string;
    icon?: string;
    modoAtivado?: boolean
}

export const NavButton = ({ route, className, direction, icon,modoAtivado, ...rest }: Props) => {
    const navigate = useNavigate();

    const handleClick = () => {
        if (route) {
            navigate(route);
        }
    };

    return (
        <div className={`${styles.wrapper} ${styles.commonButton} ${modoAtivado? styles.modoAtivado : ""} ${styles.sumir}`} onClick={handleClick} {...rest}>
            {direction ? (
                <div
                    className={`fa fa-chevron-${direction} ${styles.content}`}
                    aria-hidden={true}
                />
            ) :  <span className={`material-symbols-sharp ${styles.content}`}>
                {icon}
                </span>  
  }
        </div>
    );
};
